export const selectAccessToken = (state) => state.auth.accessToken;

export const selectUser = (state) => state.auth.user;

export const selectRole = (state) => state.auth.role;

export const selectHasCompletedOnBoarding = (state) =>
  state.auth.hasCompletedOnBoarding;

export const selectIsAuthenticated = (state) =>
  Boolean(state.auth.accessToken);

export const selectClientWallet = (state) =>
  state.auth.user?.client?.wallet ?? null;

export const selectVerifiedRefundBankDetail = (state) =>
  state.auth.user?.client?.verifiedRefundBankDetail ?? null;

export function hasVerifiedRefundBankDetail(state) {
  const detail = selectVerifiedRefundBankDetail(state);
  if (!detail || typeof detail !== "object") return false;
  return (
    Boolean(String(detail.accountHolderName ?? "").trim()) &&
    Boolean(String(detail.bankName ?? "").trim()) &&
    Boolean(String(detail.sortCode ?? "").trim()) &&
    Boolean(String(detail.accountNumber ?? "").trim())
  );
}
